import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Aidant, Patient, User} from '../../_models';
import {Router} from '@angular/router';
import {AidantService, PatientService} from '../../_services';
import {first} from 'rxjs/operators';
import {getUser} from '../../../assets/utils.js';
import {Sort} from '@angular/material/sort';

import {Question} from '../../_models';
import { FAQService } from '../../_services';

@Component({
  selector: 'app-dashboard-faq',
  templateUrl: './dashboard-faq.component.html',
  styleUrls: ['./dashboard-faq.component.scss']
})
export class DashboardFaqComponent implements OnInit {

    @ViewChild('search', {static: true}) searchField: ElementRef;

    ready = false;
    questions = [];
    sortedQuestions = [];
    currentQuestionId = '';

    constructor(private router: Router, private faqService: FAQService) {

        if (!getUser()) {
            this.router.navigate(['/login']);
        }
    }

    ngOnInit() {
        this.refreshList();
    }

    ngAfterViewChecked() {
        setTimeout(() => this.ready = true, 600);
    }

    public refreshList() {

        this.questions = [];

        this.faqService.getAll().pipe(first()).subscribe(questions => {

            for (let i = 0; i < (questions as Question[]).length; i++) {
                this.questions.push({
                    id: questions[i].id,
                    title: questions[i].title,
                    description: questions[i].description,
                });
            }
        });

        this.sortedQuestions = this.questions;
    }

    searchFaq() {
        const search = this.searchField.nativeElement.value.toLowerCase();

        this.sortedQuestions = [];
        this.questions.forEach((question) => {
            if (question.title.toLowerCase().indexOf(search) > -1
                || question.description.toLowerCase().indexOf(search) > -1) {
                this.sortedQuestions.push(question);
            }
        });

    }

    toggleQuestion(questionId: string) {
        if (questionId === this.currentQuestionId) {
            this.currentQuestionId = null;
        } else {
            this.currentQuestionId = questionId;
        }
    }
}
